import React from "react";

// MATERIAL-UI
import { TableSortLabel, Box, useTheme } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

// TYPES
import { HeadCell, Order } from "./tableTypes";

interface TableSortProps {
  headCell: HeadCell;
  order: Order;
  orderBy: string;
  excluded?: string[];
  onClick: (id: string) => void;
}

const TableSort = (props: TableSortProps): JSX.Element => {
  const { orderBy, order, headCell, excluded, onClick } = props;
  const excludedHeaders = excluded ? excluded.includes(headCell.id) : false;
  const theme = useTheme();

  return (
    <TableSortLabel
      hideSortIcon={excludedHeaders}
      active={!excludedHeaders && orderBy === headCell.id}
      direction={orderBy === headCell.id ? order : "asc"}
      onClick={(): void => onClick(headCell.id)}>
      <div
        style={{
          color: theme.palette.common.black,
          fontSize: "14px",
          lineHeight: "1.5rem",
          fontWeight: 500,
        }}>
        {headCell.label}
      </div>
      {orderBy === headCell.id && (
        <Box component="span" sx={visuallyHidden}>
          {order === "desc" ? "sorted descending" : "sorted ascending"}
        </Box>
      )}
    </TableSortLabel>
  );
};

export default TableSort;
